import React from 'react';
import { Edit, Trash2 } from 'lucide-react';

const WorkLogList = ({ 
  workLogs, 
  projectId,
  currentUserId, 
  onEdit, 
  onDelete, 
  userRole 
}) => {
  const canModifyWorkLog = (workLog) => {
    if (userRole === 'admin' || userRole === 'officeAdmin') {
      return true;
    }
    return userRole === 'technician' && workLog.technician?._id === currentUserId;
  };

  return (
    <div className="mt-4">
      <div className="mt-2 space-y-2">
        {workLogs.map((log) => (
          <div key={log._id} className="text-sm bg-gray-50 p-3 rounded flex justify-between items-start">
            <div className="flex-1">
              <div className="flex justify-between">
                <span className="text-gray-600">
                  {new Date(log.date).toLocaleDateString()} - {log.hours} hours
                </span>
                {canModifyWorkLog(log) && (
                  <div className="flex space-x-2">
                    <button
                      onClick={() => onEdit(log, projectId)}
                      className="text-blue-600 hover:text-blue-800"
                      title="Edit work log"
                    >
                      <Edit className="h-4 w-4" />
                    </button>
                    <button
                      onClick={() => onDelete(projectId, log._id)}
                      className="text-red-600 hover:text-red-800"
                      title="Delete work log"
                    >
                      <Trash2 className="h-4 w-4" />
                    </button>
                  </div>
                )}
              </div>
              {log.description && (
                <p className="text-gray-500 mt-1">{log.description}</p>
              )}
              <p className="text-gray-400 text-xs mt-1">
                By: {log.technician?.name || 'Unknown User'}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkLogList;